import { detect } from 'detect-browser';
import { v4 as uuidv4 } from 'uuid';

import Axios from 'axios';

const browser = detect();

class ApiRequest {
  /**
   * Send HTTP request (get or post).
   *
   * @param	method 	get|post
   * @param	data 	JSON formatted data to be the body of the request
   * @param	path 	Route path for backend API
   *
   * @return	A promise containing the result of the request
   */
  static async sendRequest({
    method,
    params,
    path,
    token,
    contentType = 'application/json',
  }: {
    method: string;
    params: any;
    path: string;
    token?: string;
    contentType?: string;
  }) {
    try {
      // Session ID
      let uuid = localStorage.getItem('uuid');
      if (uuid === null) {
        uuid = uuidv4();
        localStorage.setItem('uuid', uuid);
      }

      const config = {
        method,
        url: process.env.REACT_APP_API_SERVER_URL + path,
        headers: {
          'Content-Type': contentType,
          'x-access-token': token,
          'x-device-id': uuid,
          'x-request-source': 'web',
          'x-device-service-name': browser?.name,
          'x-device-service-version': browser?.version,
        },
        data: params,
      };

      const response = await Axios.request(config);
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  /**
   * Send HTTP request (get or post).
   *
   * @param 	{string} 	method 	get|post
   * @param 	{Object}	data 	JSON formatted data to be the body of the request
   * @param 	{string}	path 	Route path for backend API
   *
   * @return 	{Promise}	A promise containing the result of the request
   */
  static async sendExternalRequest({
    url,
    method,
    params,
    path,
    token = '',
    contentType = 'application/json',
  }: {
    url: string;
    method: string;
    params: any;
    path: string;
    token?: string;
    contentType?: string;
  }) {
    try {
      // Session ID
      let uuid = localStorage.getItem('uuid');
      if (uuid === null) {
        uuid = uuidv4();
        localStorage.setItem('uuid', uuid);
      }

      const config = {
        method,
        url: url + path,
        headers: {
          'Content-Type': contentType,
          'x-access-token': token,
          'x-device-id': uuid,
          'x-request-source': 'web',
          'x-device-service-name': browser?.name,
          'x-device-service-version': browser?.version,
        },
        data: params,
        timeout: 1000 * 60, // Wait for 60 seconds
      };

      const response = await Axios.request(config);
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
}

export default ApiRequest;
